import { useTranslation } from "react-i18next";

interface UsageOutstandingCellProps {
  outstandingCount: number;
  outstandingInFilterCount: number;
}

function UsageOutstandingCell({
  outstandingCount,
  outstandingInFilterCount,
}: UsageOutstandingCellProps) {
  const { t } = useTranslation();
  const showFilterSuffix =
    outstandingInFilterCount !== outstandingCount;

  return (
    <span className="font-semibold">
      {outstandingCount}
      {showFilterSuffix && (
        <span className="ml-1 font-normal text-gray-500">
          {t(
            "Analytics.Widgets.Usage.Explorer.InFilterSuffix",
            "({{count}} in filter)",
            { count: outstandingInFilterCount },
          )}
        </span>
      )}
    </span>
  );
}

export default UsageOutstandingCell;
